import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Announcement from "./sections/Announcement";
import Contact from "./sections/Contact";
import Shipping from "./sections/Shipping";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Announcement />
      <Contact />
      <Shipping />
      <Footer />
    </div>;
}